import React from 'react';

import {
  SwitchContainer,
  SwitchTrack,
  SwitchKnob,
  SwitchLabel,
  LabelText,
} from './components';

export interface ExactMatchSwitchProps {
  checked: boolean;
  onChange: (checked: boolean) => void;
  label?: string;
}

export const ExactMatchSwitch: React.FC<ExactMatchSwitchProps> = ({
  checked,
  onChange,
  label = 'Exact Match',
}) => {
  const handleClick = () => {
    onChange(!checked);
  };

  const handleKeyDown = (event: React.KeyboardEvent) => {
    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault();
      onChange(!checked);
    }
  };

  return (
    <SwitchContainer>
      <SwitchTrack
        isChecked={checked}
        onClick={handleClick}
        onKeyDown={handleKeyDown}
        role="switch"
        aria-checked={checked}
        aria-label={label}
        tabIndex={0}
      >
        <SwitchLabel isChecked={checked}>{checked ? 'ON' : 'OFF'}</SwitchLabel>
        <SwitchKnob isChecked={checked} />
      </SwitchTrack>
      <LabelText onClick={handleClick} sx={{ cursor: 'pointer' }}>
        {label}
      </LabelText>
    </SwitchContainer>
  );
};
